import enOnly from './en-only'

export default {
  ...enOnly,
  nft: {
    traits: 'Rasgos',
    creator: 'ID del Token',
    tokenId: 'Token del Token',
    contract: 'Contrato',
    noNfts: 'No se encontraron NFTs',
    notFound: 'NFT no encontrado',
    description: 'Descripción'
  },
  home: {
    stats: {
      injSupply: {
        marketCap: 'Capitalización de mercado',
        totalStaked: 'Total actualmente staked',
        currentSupply: 'Total de en circulación',
        tooltipContent:
          'El 100 % del suministro de INJ ya está en circulación. Total del circulante reportado:'
      },
      transactions: {
        blockTime: 'Tiempo de bloque',
        blockHeight: 'Altura del bloque',
        totalTransactions: 'Total de transacciones'
      },
      assets: {
        tvl: 'Valor Total de Activos',
        numberOfAssets: 'Número de activos',
        numberOfWallets: 'Número de wallets'
      },
      staked: {
        apr: 'APR de Staking',
        total: 'Total Staked',
        injBurned: 'INJ quemado'
      }
    }
  },
  block: {
    table: {
      block: {
        proposer: 'Proponente',
        height: 'Altura del bloque',
        timestamp: 'Marca de tiempo',
        'height-or-time': 'Altura/Tiempo',
        transactions: 'Transacciones',
        'proposer-or-txs': 'Proponente/Txs'
      }
    },
    hash: 'Hash del bloque',
    proposer: 'Proponente',
    title: 'Detalles del bloque',
    height: 'Altura del bloque',
    recentBlocks: 'Bloques recientes',
    updateBlocks: 'Actualizar bloques',
    notFoundDescription: 'Por favor, inténtalo de nuevo.',
    invalidTitle: '¡Ups! El siguiente formato de bloque es incorrecto:',
    invalidDescription: 'Vuelve a ingresar correctamente la altura del bloque.',
    notFoundTitle:
      'Lo sentimos, no podemos localizar este bloque en {network}:',
    stats: {
      blockTime: 'Tiempo de bloque',
      blockHeight: 'Altura del bloque',
      blockCount: 'Cantidad de bloques (Últimas 24 h)',
      transactions: 'Transacciones (Últimas 24 h)'
    }
  },
  assets: {
    table: {
      denomHolders: {
        value: 'Valor',
        address: 'Dirección',
        quantity: 'Cantidad',
        percentage: 'Porcentaje'
      },
      smartContract: {
        token: 'Token',
        'contract-address': 'Dirección del contrato'
      },
      assets: {
        token: 'Token',
        price: 'Precio',
        'total-usd-value': 'Valor en USD',
        'current-supply': 'Suministro actual'
      }
    },
    name: 'Nombre',
    type: 'Tipo',
    denom: 'Denom',
    price: 'Precio',
    token: 'Token',
    value: 'Valor',
    admin: 'Administrador',
    title: 'Activos',
    native: 'Nativo',
    decimal: 'Decimal',
    overview: 'Resumen',
    usdValue: 'Valor en USD',
    allAssets: 'Todos los activos',
    assetType: 'Tipo de activo',
    assetDetail: 'Detalles del activo',
    totalAssets: 'Total de activos',
    searchToken: 'Buscar token',
    currentSupply: 'Suministro actual',
    insuranceFund: 'Fondo de Seguro',
    smartContracts: 'Smart Contracts',
    adapterAddress: 'Dirección del adaptador',
    creatorAddress: 'Dirección del creador',
    contractAddress: 'Dirección del contrato',
    submitTokenInfo: 'Enviar información del token',
    totalAssetValue: 'Valor Total de Activos',
    tokenVerification: 'Verificación del token',
    assetsOnInj: 'Activos en Injective Chain',
    includeUnknownTokens: 'Incluir tokens desconocidos',
    stakedAssetValue: 'Valor en staking (INJ)',
    totalOnchainAssets: 'Total de activos on-chain',
    submitTokenMetadata: 'Enviar metadatos del token',
    assetsOnSmartContracts: 'Activos en Smart Contracts',
    currentSupplyTimesPrice: 'Suministro actual por precio',
    adminNote: 'La dirección de minter puede aumentar el suministro',
    tokensOnInjective: 'Cantidad de tokens en circulación en Injective',
    theAmountDisplayedMayNotBeInTheCorrectScale:
      'La cantidad mostrada puede no estar en la escala correcta',
    theInfoOfTokenExternalVerification:
      'El nombre de este token se basa en la información obtenida de su red de origen.',
    toast: {
      assetNotFound: 'Activo con denom {denom} no encontrado'
    },
    tabs: {
      assets: 'Tokens',
      'assets-smart-contracts': 'Smart Contracts'
    },
    stakingTabs: {
      'account-account-staking': 'Staking',
      'account-account-staking-unstake': 'Unstaking',
      'account-account-staking-restake': 'Restaking'
    },
    denomHolders: {
      title: 'Holders',
      value: 'Valor',
      address: 'Dirección',
      percentage: 'Porcentaje',
      quantity: 'Cantidad'
    }
  },
  wallet: {
    beta: 'Beta',
    wallet: 'Wallet',
    popular: 'Popular',
    address: 'Dirección',
    connect: 'Conectar',
    overview: 'Resumen',
    connected: 'Conectado',
    disconnect: 'Desconectar',
    otherWallets: 'Otras wallets',
    connectWallet: 'Conectar wallet',
    connectAWallet: 'Conectar una wallet',
    connectedWallet: 'Wallet conectada',
    disconnectWallet: 'Desconectar wallet',
    connectUsingTorus: 'Inicio de sesión en un clic con',
    successfullyConnected: 'Conectado correctamente',
    connectUsingBrowser: 'Conectar usando wallet del navegador',
    connectUsingHardware: 'Conectar usando una wallet hardware',
    connectWalletToUseNotifications:
      'Conecta tu wallet para usar notificaciones',
    hardwareWallet: {
      getAddresses: 'Obtener direcciones',
      getMoreAddresses: 'Obtener más direcciones',
      selectAddressToConnect: 'Selecciona la dirección a conectar',
      getAddressNote: 'Estamos obteniendo tus direcciones, por favor espera ...'
    },
    trezor: {
      trezor: 'Trezor',
      trezorBip32: 'Trezor',
      trezorBip44: 'Trezor Bip44',
      derivationPath: 'Ruta de derivación',
      selectDerivationPath: 'Selecciona ruta de derivación',
      note: 'Nota: Para asegurar una conexión fluida con tu wallet Trezor, asegúrate de usar la última versión de Chrome, tener tu dispositivo conectado y desbloqueado.'
    },
    ledger: {
      ledgerLive: 'Ledger Live',
      ledgerLegacy: 'Ledger Legacy',
      derivationPath: 'Ruta de derivación',
      selectDerivationPath: 'Selecciona ruta de derivación',
      note: 'Nota: Para asegurar una conexión fluida con tu wallet Ledger, asegúrate de usar la última versión de Chrome, tener tu dispositivo conectado, desbloqueado y la app de Ethereum abierta.'
    }
  },
  account: {
    table: {
      staked: {
        reward: 'Recompensa',
        amount: 'Cantidad',
        validator: 'Validador'
      },
      restaking: {
        amount: 'Cantidad',
        'destination-validator': 'Validador de destino',
        'source-validator': 'Validador de origen',
        'completition-time': 'Tiempo de finalización'
      },
      unstaking: {
        amount: 'Cantidad',
        validator: 'Validador',
        'completition-time': 'Tiempo de finalización'
      },
      balances: {
        price: 'Precio',
        amount: 'Cantidad',
        holding: 'Posición',
        'usd-value': 'Valor en USD',
        'unrealized-pnl': 'PnL no realizado',
        'in-use-reserved': 'En uso/Reservado',
        'available-balance': 'Balance disponible'
      },
      cw20Balances: {
        balance: 'Balance',
        holding: 'Posición',
        'contract-address': 'Dirección del contrato'
      }
    },
    cw20: 'CW',
    ibc: 'IBC',
    bank: 'Banco',
    total: 'Total',
    value: 'Valor',
    amount: 'Cantidad',
    native: 'Nativo',
    price: 'Precio',
    staked: 'Staked',
    tokens: 'Tokens',
    reward: 'Recompensa',
    address: 'Dirección',
    balance: 'Balance',
    holding: 'Posición',
    unknown: 'Desconocido',
    unstake: 'Hacer unstake',
    restake: 'Hacer restake',
    balances: 'Balances',
    cosmwasm: 'CosmWasm',
    holdings: 'Posiciones',
    usdValue: 'Valor en USD',
    validator: 'Validador',
    allAssets: 'Todos los activos',
    assetType: 'Tipo de activo',
    unbondings: 'En unstaking',
    injBalance: 'Balance de INJ',
    totalValue: 'Valor total',
    details: 'Detalles de la dirección',
    delegations: 'Delegaciones',
    bridgedERC20: 'ERC20 Puenteado',
    cw20Balances: 'Balances CW20',
    pathToOrigin: 'Ruta al origen',
    insuranceFund: 'Fondo de Seguro',
    unrealizedPnl: 'PnL no realizado',
    inUseReserved: 'En uso/Reservado',
    tradingAccount: 'Cuenta de trading',
    unknownNetwork: 'Red desconocida',
    contractAddress: 'Dirección del contrato',
    sourceValidator: 'Validador de origen',
    totalInjBalance: 'Balance total de INJ',
    whatDoesItMean: '¿Qué significa esto?',
    availableBalance: 'Balance disponible',
    claimableRewards: 'Recompensas disponibles',
    completitionTime: 'Tiempo de finalización',
    notFoundDescription: 'Por favor, inténtalo de nuevo.',
    latestTransactions: 'Últimas transacciones',
    noUnstakingFound: 'No hay activos en unstaking.',
    insuranceFundToken: 'Token del fondo de seguro',
    noStakedFound: 'No hay activos staked.',
    destinationValidator: 'Validador de destino',
    noTransactionsFound: 'No se encontraron transacciones.',
    noRestakingFound: 'No hay activos en restaking.',
    tradingAccountBalances: 'Balances de la cuenta de trading',
    isBalanceBreakdownEnabled: 'Incluir desglose de balance',
    invalidDescription:
      'Vuelve a ingresar correctamente la dirección de la cuenta.',
    invalidTitle:
      '¡Ups! El siguiente formato de dirección de cuenta es incorrecto:',
    notFoundTitle:
      'Lo sentimos, no podemos localizar esta cuenta en {network}:',
    ibcAssetPathDisplay:
      'Los activos IBC muestran una forma única de presentar el origen y rutas de transferencia.',
    amountIncludes:
      'La cantidad incluye margen, PnL no realizado de posiciones abiertas y órdenes abiertas.',
    totalValueIncludes:
      'El valor total incluye margen, PnL no realizado de posiciones abiertas, órdenes abiertas y cantidad delegada. Ten en cuenta que las posiciones y el PnL no realizado se cargan en segundo plano.',
    verified: 'Verificado',
    internalVerification: 'Verificado internamente',
    externalVerification: 'Verificado externamente',
    unverified: 'No verificado',
    tokenFactory: 'Token Factory',
    tabs: {
      'account-account-index': 'Balances',
      'account-account-transactions': 'Transacciones',
      'account-account-staking': 'Staking',
      'account-account-nft': 'NFTs'
    },
    balanceTabs: {
      'account-account-index': 'Injective',
      'account-account-index-cw20': 'CW20'
    }
  },
  markets: {
    table: {
      fundingRate: {
        time: 'Tiempo',
        'funding-rate': 'Tasa de financiación',
        'funding-interval': 'Intervalo de financiación'
      },
      realTimeFundingRate: {
        markets: 'Mercado',
        'next-funding': 'Próxima financiación',
        'hourly-interest-rate': 'Tasa de interés por hora',
        'estimated-funding-rate': 'Tasa de financiación estimada'
      },
      tradingRules: {
        markets: 'Market',
        'min-notional': 'Notional mínimo',
        'base-maker-fee': 'Comisión base del maker',
        'base-taker-fee': 'Comisión base del taker',
        'min-price-movement': 'Movimiento mínimo de precio',
        'min-amount-movement': 'Movimiento mínimo de cantidad',
        'initial-margin-ratio': 'Ratio de margen inicial',
        'maintenance-margin-ratio': 'Ratio de margen de mantenimiento'
      },
      marketInfo: {
        type: 'Tipo',
        price: 'Precio',
        markets: 'Mercado',
        volume: 'Volumen (24h)',
        'volume-in-usd': 'Volumen (24h) en USD'
      }
    },
    allMarkets: 'Todos los mercados',
    allTypes: 'Todos los tipos',
    baseDenom: 'Denominación base',
    baseMakerFee: 'Comisión base del maker',
    baseTakerFee: 'Comisión base del taker',
    derivative: 'Derivado',
    estimatedFundingRate: 'Tasa de financiación estimada',
    exchangeRelayers: 'Exchanges / Relayers',
    fundingInterval: 'Intervalo de financiación',
    fundingRate: 'Tasa de financiación',
    hourlyInterestRate: 'Tasa de interés por hora',
    includeLowVolumeMarkets: 'Incluir mercados de bajo volumen',
    initialMarginRatio: 'Ratio de margen inicial',
    lastFundingRate: 'Última tasa de financiación',
    lastTwelveHours: 'Últimas 12 horas',
    lastTwentyFourHours: 'Últimas 24 horas',
    maintenanceMarginRatio: 'Ratio de margen de mantenimiento',
    minNotional: 'Notional mínimo',
    makerFeeRate: 'Tasa de comisión del maker',
    market: 'Mercado',
    marketId: 'ID de mercado',
    marketsInfo: 'Información de mercados',
    marketDetails: 'Detalles del mercado',
    tabs: {
      markets: 'Información de mercados',
      'markets-realtime-funding-rate': 'Tasa de financiación en tiempo real',
      'markets-funding-rate-history': 'Historial de tasa de financiación',
      'markets-trading-rules': 'Reglas de trading'
    },
    marketType: 'Tipo de mercado',
    minAmountMovement: 'Movimiento mínimo de cantidad',
    minPriceMovement: 'Movimiento mínimo de precio',
    minPriceTickSize: 'Tamaño mínimo de tick de precio',
    minQuantityTickSize: 'Tamaño mínimo de tick de cantidad',
    nextFunding: 'Próxima financiación',
    oracleBase: 'Base del oráculo',
    oracleQuote: 'Cotización del oráculo',
    oracleType: 'Tipo de oráculo',
    oracleScaleFactor: 'Factor de escala del oráculo',
    perDay: 'por día',
    price: 'Precio',
    proposalId: 'ID de propuesta',
    quoteDenom: 'Denominación de cotización',
    searchMarket: 'Buscar mercado',
    spot: 'Spot',
    takerFeeRate: 'Tasa de comisión del taker',
    ticker: 'Ticker',
    time: 'Hora',
    type: 'Tipo',
    usd: 'USD',
    volume: 'Volumen (24h)',
    volumeInUsd: 'Volumen (24h) en USD',
    oneHour: '1 h',
    futures: 'Futuros',
    toast: {
      notFound: 'No se pudo obtener el mercado con ID {id}'
    }
  },
  spendPool: {
    table: {
      to: 'Para',
      from: 'De',
      amount: 'Cantidad',
      timestamp: 'Marca de tiempo',
      'block-height': 'Altura del bloque'
    },
    title: 'Módulo de distribución / Fondo comunitario',
    to: 'Para CSP',
    from: 'Desde CSP/DM',
    enterAddress: 'Introduce la dirección',
    timeRange: 'Seleccionar rango de tiempo',
    communitySpendPool: 'Fondo comunitario',
    cspDistributionModule: 'CSP / Módulo de distribución',
    enterAddressToSeeResults:
      'Introduce una dirección de Injective para ver los resultados'
  },
  transaction: {
    table: {
      transactions: {
        type: 'Tipo',
        time: 'Hora',
        block: 'Bloque',
        status: 'Estado',
        amount: 'Cantidad',
        'txn-hash': 'Hash de transacción',
        'tx-hash-and-type': 'Hash/Tipo',
        'status-and-amount': 'Estado/Cantidad'
      }
    },
    txs: 'Transacciones',
    fee: 'Comisión',
    type: 'Tipo',
    hash: 'Hash',
    time: 'Hora',
    memo: 'Memo',
    view: 'Ver',
    items: 'Elementos',
    height: 'Altura',
    events: 'Eventos',
    sender: 'Remitente',
    newTxs: 'Nuevas transacciones',
    txHash: 'Hash de transacción',
    message: 'Mensaje',
    summary: 'Resumen',
    txnHash: 'Hash de transacción',
    messages: 'Mensajes',
    errorLog: 'Registro de errores',
    exportCsv: 'Exportar CSV',
    messageType: 'Tipo de mensaje',
    tokenTransfers: 'Transferencias de tokens',
    defiActivities: 'Actividades DeFi',
    rawTransaction: 'Transacción sin procesar',
    transactionHash: 'Hash de la transacción',
    updateTransactions: 'Actualizar transacciones',
    transactionDetails: 'Detalles de la transacción',
    gasUsedAndRequested: 'Gas (Usado/Solicitado)',
    noTransactionsFound: 'No se encontraron transacciones.',
    filter: {
      types: 'Tipos',
      reset: 'Restablecer',
      filters: 'Filtros',
      allTypes: 'Todos los tipos',
      messageType: 'Tipo de mensaje',
      selectAll: 'Seleccionar todo',
      clearAll: 'Limpiar todo',
      resetMessages: 'Restablecer mensajes'
    },
    stats: {
      totalTransactions: 'Total de transacciones',
      transactionsThirtyDays: 'Transacciones (30d)',
      transactionsLast24Hours: 'Transacciones (Últimas 24 h)',
      tps: 'TPS (Últimos 100 bloques)'
    },
    voter: 'Votante',
    signer: 'Firmante',
    details: 'Detalles',
    proposer: 'Proponente',
    receiver: 'Receptor',
    depositor: 'Depositante',
    validator: 'Validador',
    subaccount: 'Subcuenta',
    orchestrator: 'Orquestador',
    hashInvalidTitle:
      '¡Ups! Se ha introducido un hash de transacción no válido:',
    hashInvalidDescription:
      'Vuelve a ingresar el hash de transacción correctamente.',
    notFoundTitle:
      'Lo sentimos, no se encontró la siguiente transacción en {network}',
    notFoundDescription:
      'El Explorador de Injective solo proporciona una vista general del estado actual de la blockchain, como el estado de tu transacción. El Explorador de Injective NO controla ninguna transacción.',
    notFoundDescriptionPoint1:
      '1) Si acabas de enviar una transacción, espera al menos 30 segundos antes de actualizar esta página.',
    notFoundDescriptionPoint2:
      '2) Tu transacción podría estar aún en la pool de TX de otro nodo, esperando ser difundida.',
    notFoundDescriptionPoint3:
      '3) Si la red está ocupada, puede que tarde un poco en aparecer tu transacción.',
    notFoundDescriptionPoint4:
      '4) Si tu transacción aún no aparece después de 1 hora, consulta con el remitente o proveedor de exchange/wallet/transacción para obtener más información.',
    proposal: {
      proposal: 'propuesta',
      yes: 'sí',
      abstain: 'abstención',
      no: 'no',
      noWithVeto: 'no con veto'
    },
    summaryType: {
      MsgExecuteContractCompatSwap:
        '{sender} intercambiando {inputAmount} {inputSymbol} por {outputAmount} {outputSymbol}'
    },
    eventLogs: {
      title: 'Registros de eventos',
      logs: 'registros'
    },
    claimId: 'Reclamo #',
    claimIdNote:
      'Se ejecutan múltiples transacciones MsgDepositClaim por cada depósito de Ethereum. Cada depósito se identifica por un claimId único.',
    generatingCsvSuccessMessage: '¡Archivo CSV generado correctamente!',
    generatingCsvErrorMessage:
      'Hubo un problema al generar el archivo CSV. Por favor, inténtalo de nuevo.'
  },
  tradeHistory: {
    table: {
      tradeHistory: {
        time: 'Hora',
        type: 'Tipo',
        side: 'Operación',
        amount: 'Cantidad',
        market: 'Mercado',
        address: 'Dirección',
        'trade-id': 'ID de operación'
      }
    },
    buy: 'Compra',
    fee: 'Comisión',
    time: 'Hora',
    type: 'Tipo',
    long: 'Long',
    side: 'Operación',
    sell: 'Venta',
    short: 'Short',
    event: 'Evento',
    filter: 'Filtrar',
    payout: 'Pago',
    market: 'Mercado',
    amount: 'Cantidad',
    address: 'Dirección',
    tradeId: 'ID de operación',
    timestamp: 'Marca de tiempo',
    spotTrade: 'Operación spot',
    timeRange: 'Rango de tiempo',
    allMarkets: 'Todos los mercados',
    blockHeight: 'Altura del bloque',
    tradeActivity: 'Actividad por tipo de operación',
    tradeIdDetails: 'Detalles del ID de operación',
    tradingActivity: 'Actividad de trading',
    tradeHistoryDaily: 'Actividad por tipo de operaciónes (24 h)',
    clearFilters: 'Limpiar filtros',
    feeRecipient: 'Receptor de comisión',
    subaccountId: 'ID de subcuenta',
    derivativeTrade: 'Operación derivada',
    filterByAddress: 'Filtrar por dirección',
    tradeHistoryDetails: 'Detalles del historial de operaciones',
    toast: {
      notFound: 'No se pudo obtener la operación con ID {id}'
    },
    tabs: {
      'trade-history-spot': 'Spot',
      'trade-history-derivatives': 'Derivados'
    }
  },
  smartContracts: {
    table: {
      smartContracts: {
        'tx-hash': 'Hash de transacción',
        address: 'Dirección',
        creator: 'Creador',
        executed: 'Ejecutado',
        'last-executed-or-created': 'Última ejecución/Creación',
        'contract-name-or-type': 'Nombre/Tipo de contrato'
      },
      wasm: {
        'tx-hash': 'Hash de transacción',
        creator: 'Creador',
        version: 'Versión',
        'id-or-type': 'ID/Tipo',
        instances: 'Instancias',
        'creation-date': 'Fecha de creación'
      },
      tokenHolders: {
        address: 'Dirección',
        balance: 'Balance'
      }
    },
    tabs: {
      'smart-contracts': 'Contratos',
      'smart-contracts-code': 'Código'
    },
    contract: {
      fee: 'Comisión',
      time: 'Hora',
      type: 'Tipo',
      admin: 'Administrador',
      denom: 'Denom',
      funds: 'Fondos',
      amount: 'Cantidad',
      height: 'Altura',
      result: 'Resultado',
      codeId: 'ID de código',
      txHash: 'Hash de transacción',
      address: 'Dirección',
      balance: 'Balance',
      created: 'Creado',
      creator: 'Creador',
      decimal: 'Decimal',
      initMsg: 'InitMsg',
      cosmwasm: 'CosmWasm',
      balances: 'Balances',
      contract: 'Contrato',
      executed: 'Ejecutado',
      tokenInfo: 'Información del token',
      tokenHolders: 'Holders de tokens',
      noInitMsg: 'Sin Init Msg',
      contractName: 'Nombre del contrato',
      creationDate: 'Fecha de creación',
      lastExecuted: 'Última ejecución',
      smartContract: 'Smart Contract',
      smartContracts: 'Smart Contracts',
      lastExecutedAt: 'Última ejecución en',
      searchContracts: 'Buscar contratos',
      updateContracts: 'Actualizar contratos',
      notFoundDescription: 'Por favor, inténtalo de nuevo.',
      smartContractDetails: 'Detalles del smart contract',
      invalidTitle:
        '¡Ups! El siguiente formato de dirección de contrato es incorrecto:',
      invalidDescription:
        'Vuelve a ingresar la dirección del contrato correctamente.',
      notFoundTitle:
        'Lo sentimos, no podemos localizar este contrato en {network}:',
      queryAndExecute: {
        max: 'Máx',
        copy: 'Copiar',
        query: 'Consulta',
        search: 'Buscar',
        execute: 'Ejecutar',
        balance: 'Balance:',
        queryMsg: 'Mensaje de consulta',
        title: 'Consultar/Ejecutar',
        jsonInput: 'Entrada JSON',
        executeMsg: 'Mensaje de ejecución',
        formatJSON: 'Formatear JSON',
        queryResult: 'Resultado de la consulta',
        attachFunds: 'Adjuntar fondos',
        selectAsset: 'Seleccionar activo',
        enterAmount: 'Introducir cantidad',
        addMoreAssets: 'Agregar más activos',
        suggestions: 'Sugerencias de mensaje',
        viewTransaction: 'Ver transacción',
        successfullyCopied: 'Copiado con éxito',
        successfullyExecuted: 'Ejecutado con éxito',
        connectToExecute: 'Conecta la wallet para ejecutar contratos',
        wallet: {
          connectWallet: 'Conectar wallet'
        },
        tabs: {
          'contract-contract-action': 'Consulta',
          'contract-contract-action-execute': 'Ejecutar'
        }
      }
    },
    code: {
      id: 'ID',
      type: 'Tipo',
      idType: 'ID/Tipo',
      codeId: 'ID de código',
      txHash: 'Hash de transacción',
      creator: 'Creador',
      version: 'Versión',
      checksum: 'Checksum',
      contract: 'Contrato',
      wasmCode: 'Código Wasm',
      instances: 'Instancias',
      wasmCodes: 'Códigos Wasm',
      permission: 'Permiso',
      codeDetail: 'Detalle del código',
      codeSchema: 'Esquema del código',
      codeViewer: 'Visor de código',
      proposalId: 'ID de propuesta',
      updateCodes: 'Actualizar códigos',
      creationDate: 'Fecha de creación',
      wasmCodeDetails: 'Detalles del código Wasm',
      permittedAddress: 'Dirección permitida',
      notFoundDescription: 'Por favor, inténtalo de nuevo.',
      invalidTitle: '¡Ups! El siguiente formato de ID de código es incorrecto:',
      invalidDescription: 'Vuelve a ingresar correctamente el ID de código.',
      notFoundTitle:
        'Lo sentimos, no podemos localizar este código en {network}:'
    }
  },
  common: {
    via: 'vía',
    code: 'Código',
    back: 'Volver',
    sent: 'enviado',
    type: 'Tipo',
    dApps: 'DApps',
    block: 'Bloque',
    fail: 'Fallido',
    amount: 'Cantidad',
    assets: 'Activos',
    blocks: 'Bloques',
    wasmCode: 'Código',
    status: 'Estado',
    failed: 'Fallido',
    inputs: 'Entradas',
    update: 'Actualizar',
    details: 'Detalles',
    outputs: 'Salidas',
    account: 'Cuenta',
    success: 'Éxito',
    markets: 'Mercados',
    chainId: 'ID de cadena',
    viewAll: 'Ver todo',
    overview: 'Resumen',
    received: 'recibido',
    contracts: 'Contratos',
    search: 'Buscar',
    time: 'Hora',
    timestamp: 'Marca de tiempo',
    transaction: 'Transacción',
    transactions: 'Transacciones',
    analytics: 'Analítica',
    activity: 'Actividad',
    all: 'Todo',
    from: 'De',
    to: 'Para',
    cosmWasm: 'CosmWasm',
    rawJson: 'JSON sin procesar',
    noItems: 'Sin elementos.'
  },
  navigation: {
    hub: 'Hub',
    network: 'Red',
    trading: 'Trading',
    ecosystem: 'Ecosistema',
    validators: 'Validadores',
    developers: 'Desarrolladores'
  },
  network: {
    terra: 'Terra',
    evmos: 'Evmos',
    axelar: 'Axelar',
    cosmos: 'Cosmos',
    osmosis: 'Osmosis',
    ethereum: 'Ethereum',
    chihuahua: 'ChiHuaHua',
    persistence: 'Persistence',
    injective: 'Injective Chain',
    mainnet: 'Mainnet',
    testnet: 'Testnet'
  },
  toast: {
    codeIdCopied: 'ID de código copiado al portapapeles',
    addressCopied: 'Dirección copiada al portapapeles',
    tradeIdCopied: 'ID de operación copiado al portapapeles',
    marketIdCopied: 'ID de mercado copiado al portapapeles',
    denomHashCopied: 'Hash de denom copiado al portapapeles',
    txHashCopied: 'Hash de transacción copiado al portapapeles',
    blockNumberCopied: 'Altura del bloque copiada al portapapeles',
    contractCopied: 'Dirección del contrato copiada al portapapeles',
    contractInitMsgCopied: 'InitMsg del contrato copiado al portapapeles',
    contractFundCopied:
      'Detalles de fondos del contrato copiados al portapapeles',
    contractTokenInfoCopied:
      'Información del contrato del token copiada al portapapeles'
  },
  networkError: {
    accountPageBankBalances: 'Error de red: no se pueden obtener los balances.',
    accountPageCW20Balances: 'Error de red: no se pueden obtener los balances.',
    accountPageSubaccountBalances:
      'Error de red: no se pueden obtener los balances.',
    accountPageTransactions:
      'Error de red: no se pueden obtener las transacciones.',
    blockDetailsPage: 'Error de red: no se puede obtener el bloque.',
    blocksPageBlocks: 'Error de red: no se pueden obtener los bloques.',
    contractDetailsPage: 'Error de red: no se puede obtener el contrato.',
    contractsPageContracts: 'Error de red: no se pueden obtener los contratos.',
    contractsPageAccountsBalance:
      'Error de red: no se pueden obtener los holders de tokens.',
    contractPageTransactions:
      'Error de red: no se pueden obtener las transacciones.',
    transactionDetailsPage: 'Error de red: no se puede obtener la transacción.',
    transactionsPageTransactions:
      'Error de red: no se pueden obtener las transacciones.',
    wasmCodePageCodes: 'Error de red: no se pueden obtener los códigos.',
    wasmCodeDetailsPage: 'Error de red: no se puede obtener el código.',
    communitySpendPool: 'Error de red: no se pueden obtener las transacciones.',
    denomHolders: 'Error de red: no se pueden obtener los holders de tokens.'
  },
  noRecord: {
    accountPageBankBalances: 'No se encontraron balances.',
    accountPageCW20Balances: 'No se encontraron balances.',
    accountPageSubaccountBalances: 'No se encontraron balances.',
    accountPageTransactions: 'No se encontraron transacciones.',
    blocksPageBlocks: 'No se encontraron bloques.',
    contractsPageContracts: 'No se encontraron smart contracts.',
    contractsPageAccountsBalance: 'No se encontraron holders de tokens.',
    genericNoRecordsFound: 'No se encontraron registros.',
    tradeHistory: 'No se pudo obtener el historial de operaciones.',
    transactionsPageTransactions: 'No se encontraron transacciones.',
    wasmCodePageCodes: '¡Contratos disponibles próximamente!',
    communitySpendPool: 'No se encontraron resultados.',
    denomHolders: 'No se encontraron holders de tokens.',
    noResultsFound: 'No hay resultados para {search}'
  },
  pagination: {
    showRows: 'Mostrar filas'
  },
  FilterClearFilterBtn: 'Limpiar filtros',
  FilterApplyBtn: 'Filtrar',
  notFound: '404 No encontrado',
  searchPlaceHolder: 'Buscar transacción, bloque o dirección',
  FooterCopyRightMsg:
    'Copyright © {year} Injective Foundation. Todos los derechos reservados.',
  maintenance: {
    title: 'Mantenimiento programado',
    description:
      'Estamos realizando actualizaciones. Durante este proceso, ciertas funciones no estarán disponibles temporalmente.',
    governance: 'Propuesta de gobernanza',
    governanceDescription:
      'Consulta los detalles sobre la última actualización de la red',
    subscribe: 'Suscribirse a Alertas',
    subscribeDescription:
      'Recibe notificaciones en tiempo real a través de Notifi',
    footer:
      'Estamos trabajando en mejorar InjScan. Gracias por tu paciencia, ¡estaremos pronto de vuelta!'
  },
  bgLoadingNote:
    'Para mejorar la experiencia de usuario, estamos cargando información externa en segundo plano.',
  notFound404: {
    title: 'Página no encontrada',
    description: 'La página que buscas no existe.',
    backToHome: 'Volver a la página principal'
  },
  injNameDoesNotExist: '{injName} no existe. Puedes reclamarlo en {link}',
  banners: {
    findOutMore: 'Más información'
  }
}
